module.exports = {
    zh: {
        garden:"园所",
        class:'班级',
        search: '搜索',
        reset: '重置',
        add: '新增', 
        number: '序号',
        cameraName: '摄像头名称',
        openTime: '开放时段',
        operation:"操作",
        update:"修改",
        addClassCamera: '添加班级摄像头',
        cancel: '取消',
        determine: '确定',
        editorOpenTime: '编辑开放时段',
        openTimePart: '开放时间段',
        timePart: '时间段',
        addTimePart: '添加时段',
        holidayAutoClose: '法定节假日自动关闭',
        delete:'删除',
        name:"名称",
        createTime:"创建时间",
        coverPhoto:"封面图片",   
        managementVideo:"管理摄像头",
        hlsUrl:"HLS流畅地址",
        hlsHighDefinitionUrl:"HLS高清地址",
        rtmpUrl:"RTMP流畅地址",
        rtmpHighDefinitionUrl:"RTMP高清地址",
        setTime: '设置时段',
        preview: '预览'
    },
    en: {
        garden:"garden",
        class:'class',
        search: 'search',
        reset: 'reset',
        add: 'add', 
        number:' number',
        cameraName: 'camera name',
        openTime: 'open time',
        operation: "operation",
        addClassCamera: 'Add class camera',
        cancel: 'cancel',
        update:"update",  
        determine: 'determine',
        editorOpenTime: 'Edit open time',
        openTimePart: 'open time',
        timePart: 'Period of time',
        addTimePart: 'add time',
        setTime: 'Set period of time',
        preview: '预览',
        delete:'delete',
        name:"name",  
        createTime:"create Timee", 
        coverPhoto:"Cover Photo",   
        managementVideo:"Management Video",
        hlsUrl:"HLS Smoothing Url",  
        hlsHighDefinitionUrl:"HLS high definition Url",
        rtmpUrl:"RTMP Smoothing Url",
        rtmpHighDefinitionUrl:"RTMP high definition Url",
        holidayAutoClose: 'Statutory holidays automatically closed'
    }  
  }
  



// WEBPACK FOOTER //
// ./src/components/i18n/lang/videoMonitoring.js